import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sc_access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function saveTokens(access, refresh) {
  localStorage.setItem("sc_access_token", access);
  if (refresh) localStorage.setItem("sc_refresh_token", refresh);
}

export function clearTokens() {
  localStorage.removeItem("sc_access_token");
  localStorage.removeItem("sc_refresh_token");
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Ha ocurrido un error. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" · ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function mediaUrl(path) {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
}
